<template>
  <div v-if="items.length" class="products-cell">
    <span
      v-for="(item, idx) in items"
      :key="`prod-${idx}`"
      class="product-chip"
      :title="item.name + (item.qty ? ' × ' + item.qty : '')"
    >
      <span class="product-chip__name">{{ item.name }}</span>
      <span v-if="item.qty" class="product-chip__qty">× {{ item.qty }}</span>
    </span>
  </div>
  <span v-else class="products-cell__empty">—</span>
</template>

<script>
export default {
  name: 'ProductsCell',
  props: {
    value: { type: String, default: '' }
  },
  computed: {
    items () {
      const raw = String(this.value || '').trim()
      if (!raw) return []
      return raw
        .split(/,\s*/)
        .map((segment) => {
          const trimmed = segment.trim()
          if (!trimmed) return null
          const match = trimmed.match(/^(.*)\s+x\s+(\d+(?:\.\d+)?)\s*$/i)
          if (match) {
            return { name: match[1].trim(), qty: match[2] }
          }
          return { name: trimmed, qty: '' }
        })
        .filter(Boolean)
    }
  }
}
</script>

<style scoped>
.products-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem 0.35rem;
  align-items: flex-start;
  white-space: normal;
  max-width: 100%;
  line-height: 1.3;
}

.product-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.18rem 0.45rem 0.18rem 0.6rem;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 600;
  color: #1f2a44;
  line-height: 1.2;
  white-space: nowrap;
  max-width: 100%;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.product-chip:hover {
  background: #e9eff7;
  border-color: #cbd5e1;
}

.product-chip__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;
}

.product-chip__qty {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #0e5b46;
  border: 1px solid rgba(14, 91, 70, 0.18);
  border-radius: 999px;
  padding: 0.02rem 0.4rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.products-cell__empty {
  color: #94a3b8;
  font-weight: 500;
}
</style>
